import { useState, useEffect } from "react";
import { BrowserRouter as Router, Switch } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Context } from '../components/containers/context/Context';
import { Modulo } from "../components/UI/module/Modulo";
import { IntlProvider } from 'react-intl';
import { FlattenMessages } from "../translations/FlattenMessages";
import Locales, { getLocalesProvider } from "../translations/Locales";
import { PrivateRoute } from "./PrivateRoute";
import { PublicRoute } from "./PublicRoute";
import { UserRedirect } from "../components/UI/publicRoute/UserRedirect";
import { setAuthenticatedUser } from "../actions/Authentication";
import { getAppURL } from "./getAppUrl";
import { useLoader } from "../hooks/useLoader";

const init = () => {
    if (window.location.search !== undefined 
        && window.location.search.indexOf('userRedirect') !== -1){
            sessionStorage.clear();
    }

    const userData = sessionStorage.getItem("isAuthenticated") === "true" 
        && sessionStorage.getItem("userData") && sessionStorage.getItem("userData") !== "" 
        ?  JSON.parse(sessionStorage.getItem("userData") ) : {};
    return {
        userRedirect: sessionStorage.getItem("userRedirect") || '',
        isAuthenticated: sessionStorage.getItem("isAuthenticated") ? true : false,
        idioma: sessionStorage.getItem("idioma") || 'es',
        ...userData
    }
}

export const Routes = () => {
    
    const [app, setApp] = useState(getAppURL);

    const [user, setUser] = useState(init);

    const [dataServicios, setDataServicios] = useState(null);

    const dispatch = useDispatch(); 
    
    const { hideLoader } = useLoader({});
    const locale = Locales(getLocalesProvider(sessionStorage.getItem("idioma")) || navigator.language.split(/[-_]/)[0], user.idPais);
    
    useEffect(() => {
        if ((window.location.search === undefined 
            || window.location.search.indexOf('userRedirect') === -1)
            && (user.isAuthenticated === 'true' || user.isAuthenticated === true)) {
            dispatch(setAuthenticatedUser(user));
            hideLoader();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user]);

    return (
        <Context.Provider value={{ user, setUser, app, setApp, dispatch, locale, dataServicios, setDataServicios }} >
            <IntlProvider locale={locale.language} messages={FlattenMessages(locale.messages)} defaultLocale="es" key={'dashboard'}>
                <Router basename={app.baseName}>
                    <Switch>
                        <PrivateRoute exact path="/dashboardAdmin" propComp={{ name : "dashBoard"}} component={Modulo} redirect={app.loginFront} isAuthenticated={!!user.isAuthenticated} />
                        <PrivateRoute exact path="/profile" propComp={{ name : "profile"}} component={Modulo} redirect={app.loginFront} isAuthenticated={!!user.isAuthenticated} />
                        <PublicRoute path="/" component={UserRedirect} isAuthenticated={!!user.isAuthenticated} />
                    </Switch>
                </Router>
            </IntlProvider>
        </Context.Provider>
    );
} 
